import request from "./request";
export default {
    logout() {
        localStorage.clear()
        return request({
            url: 'auth/logout',
            method: 'post',
            data: {}
        });
    },

    convertToSlug(Text) {
        return Text.toLowerCase().replace(/ /g, '-').replace(/[^\w-]+/g, '');
    },

    updateTourVisited(id) {
        return request({
            url: "user/update-tour-status/" + id,
            method: "POST",
            data: {
                'tour_visited': '1'
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/services/helper.js